import { render, staticRenderFns } from "./FourhAdminComp.vue?vue&type=template&id=68e211c4&scoped=true&"
import script from "./FourhAdminComp.vue?vue&type=script&lang=js&"
export * from "./FourhAdminComp.vue?vue&type=script&lang=js&"
import style0 from "./FourhAdminComp.vue?vue&type=style&index=0&id=68e211c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e211c4",
  null
  
)

export default component.exports